import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {
    PRIVILEGE_CREATE,
    PRIVILEGE_FETCH,
    PRIVILEGE_FETCH_DESC,
    PRIVILEGE_UPDATE,
} from './types';

export const privilegeUpdateDesc = (data) => {
    return (dispatch) => {
        firebase.database().ref('privileges/').update(data)
        .then(res => {
            window.location = "/admin/privilege"
        })
    }
}

export const privilegeFetchDesc = () => {
    return (dispatch) => {
        let	privilegesRef = firebase.database().ref('privileges/desc')
		privilegesRef.once('value', function(snapshot) {
			dispatch({ type: PRIVILEGE_FETCH_DESC, payload: snapshot.val() })
		})
    }
}

export const privilegeDeleteById = (id, img) => {
	return (dispatch) => {
        firebase.database().ref('privileges/'+id).remove()
        .then(() => removeOldFile(img))
	}
}

const removeOldFile = (src) => {
    var ref = firebase.storage().ref().child(src);
    // Delete the file
    ref.delete().then(() => {
        window.location = "/admin/privilege"
    }).catch((error) => {
        window.location = "/admin/privilege"
    });
}

export const privilegeUpdateById = (id, data, oldImg) => {
    return (dispatch) => {
        dispatch({ type: PRIVILEGE_UPDATE, payload: true })
        if(data.img){
            const filename = Date.now()+"."+data.img.name.split('.').pop()
            // Upload File to firebase storage
            const storage = firebase.storage().ref()
            const fileRef = storage.child('privilege/'+filename)
            fileRef.put(data.img).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    data.img = url
                    firebase.database().ref('privileges/'+id).update(data)
                    .then(res => {
                        removeOldFile(oldImg)
                    })
                    .catch(err => {
                        dispatch({ type: PRIVILEGE_CREATE, payload: false })
                    })

                }).catch((err) => {
                    dispatch({ type: PRIVILEGE_CREATE, payload: false })
                })
            })
        } else {
            delete data.img
            delete data.oldImg
            firebase.database().ref('privileges/'+id).update(data)
            .then(res => window.location = "/admin/privilege")
            .catch(err => dispatch({ type: PRIVILEGE_UPDATE, payload: false }))
        }
		
	}
}

export const privilegeFetch = () => {
    return (dispatch) => {
        let	privilegesRef = firebase.database().ref('privileges')
		privilegesRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object') {
                    data.push(item)
                }
			})
			dispatch({ type: PRIVILEGE_FETCH, payload: data.reverse() });
		})
    }
}

export const privilegeCreate = (data) => {
    return (dispatch) => {
        dispatch({ type: PRIVILEGE_CREATE, payload: true })
        const filename = Date.now()+"."+data.img.name.split('.').pop()
        const storage = firebase.storage().ref()
        const fileRef = storage.child('privilege/'+filename)
        fileRef.put(data.img).then(()=>{
            fileRef.getDownloadURL().then((url) => {
                const privilegesRef = firebase.database().ref('privileges').push()
                const id = privilegesRef.key
                data.id = id
                data.img = url
                privilegesRef.set(data)
                .then(response => {
                    window.location = "/admin/privilege"
                })
                .catch(err => {
                    console.log("privilegeCreate", err)
                })

            }).catch((error) => {
                dispatch({ type: PRIVILEGE_CREATE, payload: false })
                console.log('fail to create privilege')
            })
        })
    }
}


// // Upload File to firebase storage
// const uploadFile = async (file) => {
//     const filename = Date.now()+"."+file.name.split('.').pop()
//     const storage = firebase.storage().ref()
//     const fileRef = storage.child(filename)
//     fileRef.put(file).then(()=>{
//         fileRef.getDownloadURL().then((url) => {
//             return url
//         }).catch((error) => {
//             console.log(error)
//             return ""
//         })
//     })
// }